module.exports = __webpack_public_path__ + "img/landing_pages_preview.d14cdcb7.jpg";